export default __webpack_public_path__ + "static/media/userFlow.6d31a77c.jpg";